"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _ethFuncs = require("./ethereum/ethFuncs");
function decodeData(abiType, data) {
  if (data.startsWith('0x')) {
    data = data.slice(2);
  }
  if (data.length === 0) {
    return null;
  }
  var dataBuffer;
  try {
    dataBuffer = Buffer.from(data, 'hex');
  } catch (e) {
    throw new Error('Invalid data provided: not an hex string');
  }
  if (dataBuffer.length % 32 !== 0) {
    throw new Error('Invalid data provided: data length is not a multiple of 32');
  }
  var uintData = dataBuffer.readUIntBE(0, 32);
  switch (abiType) {
    case 'string':
      var dataLocation = uintData;
      if (dataLocation % 32 !== 0) {
        throw new Error('Invalid data provided while decoding string: ' + 'first 32byte word is not a valid address');
      }
      if (dataLocation + 64 > dataBuffer.length) {
        throw new Error('Invalid data provided while decoding string: ' + 'not enough data to decode length and first word at given location');
      }
      var dataLength = dataBuffer.readUIntBE(dataLocation, 32);
      var expectedLength = Math.ceil((dataLocation + 32 + dataLength) / 32) * 32;
      console.log("expected:", expectedLength);
      if (dataBuffer.length !== expectedLength) {
        throw new Error('Invalid data provided while decoding string: ' + 'not enough data to decode advertised string');
      }
      var dataValue = dataBuffer.slice(dataLocation + 32, dataLocation + 32 + dataLength);
      return dataValue.toString();
    case 'uint':
    case 'uint256':
      return uintData;
    case 'number/100':
      return (decodeData('number', data) / 100.0).toString();
    case 'number':
      var shortData = '0x' + data.slice(-12);
      var a = parseInt(shortData, 16);
      if (a > 34359738368 * 4096) {
        a -= 68719476736 * 4096;
      }
      return a;
    case 'bool':
      return uintData === 1;
    default:
      throw new Error("Unsupported ABI type: ".concat(abiType));
  }
}
var BcReadAbstract = /*#__PURE__*/function () {
  function BcReadAbstract() {
    (0, _classCallCheck2["default"])(this, BcReadAbstract);
  }
  (0, _createClass2["default"])(BcReadAbstract, [{
    key: "getContractStatus",
    value:
    // Get Global status of the contract
    function getContractStatus() {
      return this.read(this.contracts[0], '0x8b3c7c69');
    }
    // Get Global infos: Tax destinary Account
  }, {
    key: "getTaxAccount",
    value: function getTaxAccount() {
      return this.read(this.contracts[0], '0x4f2eabe0');
    }
    // Get Historical infos infos: Global balance
  }, {
    key: "getHistoricalGlobalBalance",
    value: function () {
      var _getHistoricalGlobalBalance = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(walletAddress, blockNb) {
        var data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.read(this.contracts[0], '0x70a08231', [(0, _ethFuncs.getNakedAddress)(walletAddress)], blockNb);
            case 2:
              data = _context.sent;
              return _context.abrupt("return", decodeData('number/100', data));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getHistoricalGlobalBalance(_x, _x2) {
        return _getHistoricalGlobalBalance.apply(this, arguments);
      }
      return getHistoricalGlobalBalance;
    }()
  }, {
    key: "getVersion",
    value: function () {
      var _getVersion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.read(this.contracts[0], '0x54fd4d50');
            case 2:
              data = _context2.sent;
              return _context2.abrupt("return", decodeData('string', data));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getVersion() {
        return _getVersion.apply(this, arguments);
      }
      return getVersion;
    }() // //////////////////////////////////////////////////////////////////////////
    // Generic read function
  }, {
    key: "getAmount",
    value: function () {
      var _getAmount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(address, walletAddress) {
        var data;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.read(this.contracts[0], address, [(0, _ethFuncs.getNakedAddress)(walletAddress)]);
            case 2:
              data = _context3.sent;
              return _context3.abrupt("return", decodeData('number/100', data));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAmount(_x3, _x4) {
        return _getAmount.apply(this, arguments);
      }
      return getAmount;
    }()
  }, {
    key: "getAccInfo",
    value: function () {
      var _getAccInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(address, walletAddress) {
        var data;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.read(this.contracts[0], address, [(0, _ethFuncs.getNakedAddress)(walletAddress)]);
            case 2:
              data = _context4.sent;
              return _context4.abrupt("return", decodeData('number', data));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAccInfo(_x5, _x6) {
        return _getAccInfo.apply(this, arguments);
      }
      return getAccInfo;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(contract, address, args) {
        var blockNb,
          ethCall,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              blockNb = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : 'pending';
              args = args || [];
              ethCall = (0, _ethFuncs.getDataObj)(contract, address, args);
              if (blockNb !== 'pending') {
                blockNb = '0x' + new _bignumber["default"](blockNb).toString(16);
              }
              _context5.prev = 4;
              _context5.next = 7;
              return this.ajaxReq.getEthCallAt(ethCall, blockNb);
            case 7:
              return _context5.abrupt("return", _context5.sent);
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](4);
              throw new Error("Failed read contract: ".concat(contract, ", fn: ").concat(address));
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 10]]);
      }));
      function read(_x7, _x8, _x9) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "getAmountForElement",
    value: function () {
      var _getAmountForElement = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(contract, functionAddress, callerAddress, elementAddress) {
        var data;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.read(contract, functionAddress, [(0, _ethFuncs.getNakedAddress)(callerAddress), (0, _ethFuncs.getNakedAddress)(elementAddress)]);
            case 2:
              data = _context6.sent;
              return _context6.abrupt("return", decodeData('number/100', data));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getAmountForElement(_x10, _x11, _x12, _x13) {
        return _getAmountForElement.apply(this, arguments);
      }
      return getAmountForElement;
    }()
  }, {
    key: "getElementInList",
    value: function () {
      var _getElementInList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(contract, mapFunctionAddress, amountFunctionAddress, callerAddress, index, list, indMin) {
        var data, amount, address, element;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(index < indMin)) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return", list);
            case 2:
              _context7.next = 4;
              return this.read(contract, mapFunctionAddress, [(0, _ethFuncs.getNakedAddress)(callerAddress), (0, _ethFuncs.padLeft)(new _bignumber["default"](index).toString(16), 64)]);
            case 4:
              data = _context7.sent;
              _context7.next = 7;
              return this.getAmountForElement(contract, amountFunctionAddress, callerAddress, data);
            case 7:
              amount = _context7.sent;
              address = '0x' + data.substring(data.length - 40);
              element = {
                address: address,
                amount: amount
              };
              list.unshift(element);
              return _context7.abrupt("return", this.getElementInList(contract, mapFunctionAddress, amountFunctionAddress, callerAddress, index - 1, list, indMin));
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getElementInList(_x14, _x15, _x16, _x17, _x18, _x19, _x20) {
        return _getElementInList.apply(this, arguments);
      }
      return getElementInList;
    }()
  }]);
  return BcReadAbstract;
}();
exports["default"] = BcReadAbstract;
var fnHashes = [{
  fn: 'getAmount',
  hashes: {
    getGlobalBalance: '0x70a08231',
    getNantBalance: '0xae261aba',
    getCmBalance: '0xbbc72a17',
    getCmLimitBelow: '0xcc885a65',
    getCmLimitAbove: '0xae7143d6'
  }
}, {
  fn: 'getAccInfo',
  hashes: {
    getAccountStatus: '0x61242bdd',
    getAccountType: '0xba99af70',
    getIsOwner: '0x2f54bf6e',
    getTaxAmount: '0x98a9cfac',
    getLegTaxAmount: '0x48455399',
    getTotalAmount: '0x18160ddd'
  }
}];
fnHashes.forEach(function (_ref) {
  var fn = _ref.fn,
    hashes = _ref.hashes;
  var _loop = function _loop() {
    var fnHash = hashes[fnName];
    BcReadAbstract.prototype[fnName] = function (walletAddress) {
      return this[fn](fnHash, walletAddress);
    };
  };
  for (var fnName in hashes) {
    _loop();
  }
});
// Handle lists
var ListFunction = {
  Allowance: {
    count: 'aa7adb3d',
    map: 'b545b11f',
    amount: 'dd62ed3e'
  },
  RequestToApprove: {
    count: 'debb9d28',
    map: '726d0a28',
    amount: '3537d3fa'
  },
  PendingRequest: {
    count: '418d0fd4',
    map: '0becf93f',
    amount: '09a15e43'
  },
  Delegation: {
    count: '58fb5218',
    map: 'ca40edf1',
    amount: '046d3307'
  },
  MyDelegation: {
    count: '7737784d',
    map: '49bce08d',
    amount: 'f24111d2'
  },
  AcceptedRequest: {
    count: '8d768f84',
    map: '59a1921a',
    amount: '958cde37'
  },
  RejectedRequest: {
    count: '20cde8fa',
    map: '9aa9366e',
    amount: 'eac9dd4d'
  }
};
var _loop2 = function _loop2() {
  var configList = ListFunction[key];
  BcReadAbstract.prototype["get".concat(key, "List")] = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(walletAddress, indMin, indMax) {
      var data, count, list, index;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            // Simple protection against ill inputs on indMin and indMax and to
            // avoid unwanted infinite loops
            indMax = indMax || 0;
            indMin = indMin || 0;
            _context8.next = 4;
            return this.read(this.contracts[1], "0x".concat(configList.count), [(0, _ethFuncs.getNakedAddress)(walletAddress)]);
          case 4:
            data = _context8.sent;
            count = decodeData('number', data);
            list = [];
            index = Math.min(count - 1, indMax);
            return _context8.abrupt("return", this.getElementInList(this.contracts[1], "0x".concat(configList.map), "0x".concat(configList.amount), walletAddress, index, list, indMin));
          case 9:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    return function (_x21, _x22, _x23) {
      return _ref2.apply(this, arguments);
    };
  }();
};
for (var key in ListFunction) {
  _loop2();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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